import React, { ReactNode } from 'react';
import styles from './assets/order-screen.module.scss';
import classNames from 'classnames';
import OrdersGrid from './components/OrdersGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateOrderButton from './components/CreateOrderButton';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IOrder } from 'src/types/order';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IOrder>;
    inProgress: boolean;
    serviceTypes: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class OrdersList extends React.Component<Props> {
    componentDidMount() {
        this.props.getServiceTypes({
            page: 1,
        });
    }

    public render(): ReactNode {
        const { data, getData, serviceTypes, inProgress } = this.props;

        return (
            <RoleLayout>
                <div className={`${classNames('pageHeading')}`}>
                    <h2 className={`${classNames('pageHeadingTitle')}`}>
                        ORDERS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? <CreateOrderButton /> : null}
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <OrdersGrid data={data} serviceTypes={serviceTypes} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default OrdersList;
